import { __awaiter } from "tslib";
import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import httpService from '../services/http.service';
import { currency_format, t } from '../utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFullScreen, toogleFullScreen } from '../fullscreen';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import SelectSearch from 'react-select-search';
class PointOfSaleEdit extends Component {
    constructor(props) {
        super(props);
        this.specialCustomerPrice = (prod) => {
            if (!this.state.customer)
                return prod.price || 0;
            if (this.state.customer.order_details.length == 0)
                return prod.price || 0;
            var newProd = this.state.customer.order_details.find(p => p.product_id === prod.id);
            if (!newProd)
                return prod.price || 0;
            return newProd.price || 0;
        };
        this.getAppSettings = () => {
            return JSON.parse(this.props.settings);
        };
        this.setupForEditing = () => __awaiter(this, void 0, void 0, function* () {
            var order = JSON.parse(this.props.order);
            console.log(order);
            this.setState({ orderId: order.id });
            this.setState({ orderNumber: order.number });
            this.setState({ deliveryCharge: order.delivery_charge });
            this.setState({ tax: order.tax_rate });
            this.setState({ vatType: order.vat_type });
            this.setState({ discount: order.discount });
            this.setState({ receiptType: order.receipt_type });
            let cartItems = [];
            order.order_details.map((item) => {
                let cartItem = {
                    cartId: uuid(),
                    id: item.product.id,
                    name: item.product.name,
                    full_name: item.product_name,
                    quantity: item.quantity,
                    old_quantity: item.quantity,
                    old_area: item.area,
                    image_url: item.product.image_url,
                    barcode: item.barcode,
                    sku: item.sku,
                    in_stock: item.in_stock,
                    track_stock: item.track_stock,
                    continue_selling_when_out_of_stock: item.continue_selling_when_out_of_stock,
                    price: item.price,
                    width: item.width,
                    length: item.length,
                    area: item.area,
                    is_rounded: item.is_rounded,
                    num_rounded: item.num_rounded,
                    radius: item.radius,
                    service: item.service,
                    side_a: item.side_a,
                    side_b: item.side_b,
                    is_double: item.is_double,
                    product_a_id: item.product_a,
                    product_b_id: item.product_b
                };
                cartItems.push(cartItem);
            });
            this.setState({ cart: cartItems });
            if (order.customer) {
                this.setState({
                    customer: {
                        id: order.customer.id,
                        name: order.customer.name,
                        full_address: order.customer.full_address,
                        contact: order.customer.contact,
                        order_details: []
                    }
                });
            }
            this.setState({ tenderAmount: order.tender_amount });
            this.setState({ remarks: order.remarks });
            this.setState({ receiptType: order.receipt_type });
        });
        this.randomString = () => {
            return (Math.random() + 1).toString(36).substring(2);
        };
        this.getCategories = () => {
            httpService
                .get(`/inventory/categories`)
                .then((response) => {
                this.setState({ categories: response.data.data });
            })
                .finally(() => {
                this.setState({ isLoadingCategories: false });
            });
        };
        this.updateOrder = () => {
            if (this.state.cart.length == 0) {
                toast.error(t('No items has been added!', 'لم يتم إضافة اية اصناف!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/orders/update/${this.state.orderId}`, {
                customer: this.state.customer,
                cart: this.state.cart,
                deletedProducts: this.state.deletedProducts,
                subtotal: this.state.subtotal,
                total: this.state.total,
                tax_rate: this.state.tax || 0,
                vat_type: this.state.vatType,
                delivery_charge: this.state.deliveryCharge || 0,
                discount: this.state.discount || 0,
                remarks: this.state.remarks,
                tender_amount: this.state.tenderAmount || 0,
                change: this.getChangeAmount(),
                receipt_type: this.state.receiptType,
                _method: 'PUT'
            })
                .then((response) => {
                if (response.data) {
                    this.closeModal('checkoutModal');
                    Swal.fire({
                        title: t('Updated', 'تم التحديث'),
                        text: t('Invoice has been updated!', '"تم تحديث الفاتورة!"'),
                        icon: 'success',
                        allowOutsideClick: false,
                        confirmButtonText: t('Continue', 'المتابعة')
                    }).then(result => {
                        if (result.isConfirmed) {
                            window.location.href = `/orders/${this.state.orderId}`;
                        }
                    });
                }
            })
                .finally(() => this.setState({ isLoading: false }));
        };
        this.categoryClick = (category) => {
            this.setState({ showProducts: true });
            this.setState({ products: category.products || [] });
            this.setState({ categoryName: category.name });
        };
        this.backClick = () => {
            this.setState({ showProducts: false });
            this.setState({ products: [] });
            this.setState({ categoryName: '' });
        };
        this.toggleFullScreen = () => {
            toogleFullScreen();
            this.setState({ isFullScreen: !this.state.isFullScreen });
        };
        this.goToOrderList = () => {
            window.location.href = '/orders';
        };
        this.calculateTotal = () => {
            let _total = 0;
            let _subtotal = 0;
            if (this.state.cart.length > 0) {
                this.state.cart.map((item) => {
                    if (this.state.receiptType == 'glass_receipt') {
                        _subtotal += (item.price || 0) * (item.area || 0);
                    }
                    else {
                        _subtotal += (item.price || 0) * (item.quantity || 0);
                    }
                });
            }
            let taxValue = 0;
            if (this.state.vatType == 'add') {
                if ((this.state.tax || 0) > 0 && (this.state.tax || 0) <= 100) {
                    taxValue = (Number(this.state.tax || 0) * Number(_subtotal)) / 100;
                }
            }
            _total = Number(_subtotal) + Number(taxValue) + Number(this.state.deliveryCharge || 0) - Number(this.state.discount || 0);
            this.setState({ subtotal: _subtotal });
            this.setState({ total: _total });
            // this.setState({ tenderAmount: _total });
        };
        this.getVat = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            var taxAmount = this.getTaxAmount();
            return Math.round(Number(grossAmount) - Number(taxAmount));
        };
        this.getTaxAmount = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            return Math.trunc(Number(grossAmount) / Number(Number(1) + Number(vat) / Number(100)));
        };
        this.getTotalTax = () => {
            let taxValue = 0;
            if (Number(this.state.tax || 0) > 0 && Number(this.state.tax || 0) <= 100) {
                taxValue = (Number(this.state.tax || 0) * Number(this.state.subtotal)) / 100;
            }
            return Number(taxValue);
        };
        this.handleDiscountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var discountValue = value == '' ? undefined : Number(value);
            this.setState({ discount: discountValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleTaxChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var taxValue = value == '' ? undefined : Number(value);
            this.setState({ tax: taxValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleDeliveryChargeChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var deliveryChargeValue = value == '' ? undefined : Number(value);
            this.setState({ deliveryCharge: deliveryChargeValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleReceiptTypeChange = (event) => {
            this.setState({ receiptType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemQuantity = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = value == '' ? undefined : Number(value);
            _prod.area = this.calculateProductArea(_prod);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemWidth = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.width = value == '' ? undefined : Number(value);
            _prod.area = this.calculateProductArea(_prod);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemNumRounded = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.num_rounded = value == '' ? undefined : Number(value);
            _prod.area = this.calculateProductArea(_prod);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemRadius = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.radius = value == '' ? undefined : Number(value);
            _prod.area = this.calculateProductArea(_prod);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemLength = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.length = value == '' ? undefined : Number(value);
            _prod.area = this.calculateProductArea(_prod);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.handleItemRoundedChange = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            _prod.is_rounded = value == 'true';
            this.setState({ cart: cartItems }, () => {
                let cartItems = this.state.cart;
                let _prod = this.state.cart.find(p => p.cartId === item.cartId);
                if (!_prod)
                    return;
                _prod.area = this.calculateProductArea(_prod);
                this.setState({ cart: cartItems }, () => {
                    this.calculateTotal();
                });
            });
        };
        this.calculateProductArea = (_prod) => {
            var area = Number(_prod.length || 0) * Number(_prod.width || 0);
            var divideValue = Number(this.getAppSettings().divideValue);
            var qty = Number(_prod.quantity || 0);
            var value = (area * qty) / divideValue;
            var checkedValue = Math.ceil(value * 100) / 100;
            if (_prod.is_double) {
                if (checkedValue < 0.5)
                    return 0.5;
            }
            return checkedValue;
        };
        this.updateItemArea = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.area = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPrice = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.currencyFormatValue = (number) => {
            var settings = JSON.parse(this.props.settings);
            return currency_format(number, settings.currencyPrecision, settings.currencyDecimalSeparator, settings.currencyThousandSeparator, settings.currencyPosition, settings.currencySymbol, settings.trailingZeros);
        };
        this.getChangeAmount = () => {
            return (this.state.tenderAmount || 0) - this.state.total;
        };
        this.handleTenderAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var tenderAmount = value == '' ? undefined : Number(value);
            this.setState({ tenderAmount: tenderAmount });
        };
        this.handleRemarksChange = (event) => {
            this.setState({ remarks: event.currentTarget.value });
        };
        this.removeItem = (item) => {
            let newCartItems = this.state.cart.filter(i => i.cartId != item.cartId);
            this.setState({ cart: newCartItems }, () => {
                this.calculateTotal();
                this.setState({ deletedProducts: [item, ...this.state.deletedProducts] });
            });
        };
        this.addToCart = (product) => {
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                image_url: product.image_url,
                price: this.specialCustomerPrice(product),
                barcode: product.barcode,
                sku: product.sku,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: 1,
                old_quantity: 0,
                old_area: 0,
                width: 1,
                length: 1,
                area: 0.01,
                is_rounded: false,
                num_rounded: 4,
                radius: 0,
                service: null,
                side_a: 0,
                side_b: 0,
                is_double: false,
                product_a_id: null,
                product_b_id: null
            };
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
        };
        this.handleSearchSubmit = (event) => {
            event.preventDefault();
            let search = this.state.searchValue;
            if (!search)
                return;
            let searchValue = search.toLowerCase().trim();
            let productFound = false;
            this.state.categories.map((category) => {
                let _prod = category.products.find(p => { var _b, _j; return p.name.toLowerCase().includes(searchValue) || ((_b = p === null || p === void 0 ? void 0 : p.barcode) === null || _b === void 0 ? void 0 : _b.toLowerCase()) == searchValue || ((_j = p === null || p === void 0 ? void 0 : p.sku) === null || _j === void 0 ? void 0 : _j.toLowerCase()) == searchValue; });
                if (_prod) {
                    this.addToCart(_prod);
                    productFound = true;
                    return;
                }
            });
            if (!productFound) {
                toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
            }
        };
        this.handleSearchChange = (event) => {
            this.setState({ searchValue: event.currentTarget.value });
        };
        this.handleCustomerSearchChange = (event) => {
            var searchQuery = event.currentTarget.value.trim();
            if (!searchQuery) {
                this.setState({ customers: [] });
                return;
            }
            httpService
                .get(`/customers/search/all?query=${searchQuery}`)
                .then((response) => {
                this.setState({ customers: response.data.data });
            })
                .finally(() => { });
        };
        this.setCustomer = (customer) => {
            this.setState({ customer: customer });
        };
        this.closeModal = (id) => {
            const createModal = document.querySelector(`#${id}`);
            if (createModal) {
                var modalInstance = Modal.getInstance(createModal);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        };
        this.createCustomer = (e) => {
            e.preventDefault();
            if (!this.state.customerName) {
                toast.error(t('Customer name is required!', 'اسم الزبون مطلوب!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/customers/create-new`, {
                name: this.state.customerName,
                email: this.state.customerEmail,
                mobile: this.state.customerMobile,
                city: this.state.customerCity,
                building: this.state.customerBuilding,
                street_address: this.state.customerStreet,
                floor: this.state.customerFloor,
                apartment: this.state.customerApartment
            })
                .then((response) => {
                this.setCustomer(response.data.data);
                this.setState({ customerName: '' });
                this.setState({ customerEmail: '' });
                this.setState({ customerMobile: '' });
                this.setState({ customerBuilding: '' });
                this.setState({ customerStreet: '' });
                this.setState({ customerFloor: '' });
                this.setState({ customerApartment: '' });
                var form = document.getElementById('create-customer-form');
                if (form) {
                    form.reset();
                }
                this.closeModal('createCustomerModal');
                toast.info(t('Customer has been created', 'تم إنشاء زبون جديد'));
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.handleVatTypeChange = (event) => {
            this.setState({ vatType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.handleCustomerNameChange = (event) => {
            this.setState({ customerName: event.currentTarget.value });
        };
        this.handleCustomerEmailChange = (event) => {
            this.setState({ customerEmail: event.currentTarget.value });
        };
        this.handleCustomerMobileChange = (event) => {
            this.setState({ customerMobile: event.currentTarget.value });
        };
        this.handleCustomerCityChange = (event) => {
            this.setState({ customerCity: event.currentTarget.value });
        };
        this.handleCustomerStreetChange = (event) => {
            this.setState({ customerStreet: event.currentTarget.value });
        };
        this.handleCustomerBuildingChange = (event) => {
            this.setState({ customerBuilding: event.currentTarget.value });
        };
        this.handleCustomerFloorChange = (event) => {
            this.setState({ customerFloor: event.currentTarget.value });
        };
        this.handleCustomerApartmentChange = (event) => {
            this.setState({ customerApartment: event.currentTarget.value });
        };
        this.modalCloseButton = () => {
            return (React.createElement("i", { className: "bi bi-x-circle align-middle text-black fs-4 cursor-pointer user-select-none text-danger-hover", "data-bs-dismiss": "modal", "aria-label": "Close" }));
        };
        this.allProducts = () => {
            var products = [];
            this.state.categories.map((category) => {
                category.products.map((product) => {
                    products.push(product);
                });
            });
            return products;
        };
        this.filterOptions = () => {
            var options = [];
            this.state.categories.map((category) => {
                category.products.map((product) => {
                    options.push({
                        key: product.id,
                        name: `${product.full_name} ${this.currencyFormatValue(product.price)}`,
                        value: product.id
                    });
                });
            });
            return options;
        };
        this.updateDoubleVitrageItemQuantity = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            this.setState({ doubleVitrageQuantity: value == '' ? undefined : Number(value) }, () => {
                this.calculateDoubleVitrageArea();
            });
        };
        this.updateDoubleVitrageItemWidth = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            this.setState({ doubleVitrageWidth: value == '' ? undefined : Number(value) }, () => {
                this.calculateDoubleVitrageArea();
            });
        };
        this.updateDoubleVitrageItemLength = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            this.setState({ doubleVitrageLength: value == '' ? undefined : Number(value) }, () => {
                this.calculateDoubleVitrageArea();
            });
        };
        this.updateDoubleVitrageItemArea = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            this.setState({ doubleVitrageArea: value == '' ? undefined : Number(value) });
        };
        this.calculateDoubleVitrageArea = () => {
            var area = Number(this.state.doubleVitrageLength || 0) * Number(this.state.doubleVitrageWidth || 0);
            var divideValue = Number(this.getAppSettings().divideValue);
            var qty = Number(this.state.doubleVitrageQuantity || 0);
            var value = area / divideValue;
            var checkedValue = Math.ceil(value * 100) / 100;
            if (checkedValue < 0.5) {
                this.setState({ doubleVitrageArea: 0.5 * qty });
            }
            else {
                this.setState({ doubleVitrageArea: Math.ceil(value * qty * 100) / 100 });
            }
        };
        this.addDoubleVitrageItems = (reset = true) => {
            let cartItems = this.state.cart;
            let itemA = this.allProducts().find(p => p.id === this.state.doubleVitrageItemA);
            let itemB = this.allProducts().find(p => p.id === this.state.doubleVitrageItemB);
            if (!itemA)
                return;
            if (!itemB)
                return;
            let cartItem = this.doubleVitrageItemCart(itemA, itemB);
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
                this.closeModal('doubleVitrageModal');
                if (reset) {
                    this.setState({ doubleVitrageItemA: null });
                    this.setState({ doubleVitrageItemB: null });
                    this.setState({ doubleVitrageWidth: 1 });
                    this.setState({ doubleVitrageLength: 1 });
                    this.setState({ doubleVitrageArea: 1 });
                    this.setState({ doubleVitrageQuantity: 1 });
                }
            });
        };
        this.doubleVitrageItemCart = (productA, productB) => {
            return {
                cartId: uuid(),
                id: productA.id,
                name: productA.name,
                full_name: `Double ${productA.full_name} + ${productB.full_name}`,
                image_url: productA.image_url,
                price: Number(this.specialCustomerPrice(productA)) + Number(this.specialCustomerPrice(productB)),
                barcode: productA.barcode,
                sku: productA.sku,
                in_stock: productA.in_stock,
                track_stock: productA.track_stock,
                continue_selling_when_out_of_stock: productA.continue_selling_when_out_of_stock,
                quantity: this.state.doubleVitrageQuantity,
                old_quantity: 0,
                old_area: 0,
                width: this.state.doubleVitrageWidth,
                length: this.state.doubleVitrageLength,
                area: this.state.doubleVitrageArea,
                is_rounded: false,
                num_rounded: 4,
                radius: 0,
                service: null,
                side_a: 0,
                side_b: 0,
                is_double: true,
                product_a_id: productA.id,
                product_b_id: productB.id
            };
        };
        this.handleModalServiceBtnClick = (item) => {
            var areaToCalc = Number((item.width || 0) * 2) + Number((item.length || 0) * 2);
            this.setState({
                serviceItem: {
                    id: item.id,
                    name: item.full_name,
                    image_url: item.image_url,
                    width: item.width,
                    length: item.length,
                    area: (areaToCalc / 100) * (item.quantity || 0),
                    price: 1,
                    quantity: item.quantity,
                    side1: 2,
                    side2: 2,
                    type: item.is_double ? 'Decor' : 'Glass Polishing'
                }
            });
        };
        this.handleModalServiceCloseBtnClick = () => {
            this.setState({ serviceItem: undefined });
        };
        this.handleModalServiceAddBtnClick = () => {
            var serviceItem = this.state.serviceItem;
            if (!serviceItem)
                return;
            var cartItem = {
                cartId: uuid(),
                id: serviceItem.id,
                name: serviceItem.name,
                full_name: serviceItem.type || '',
                image_url: serviceItem.image_url,
                price: serviceItem.price,
                barcode: '',
                sku: '',
                old_quantity: 0,
                old_area: 0,
                in_stock: 0,
                track_stock: false,
                continue_selling_when_out_of_stock: false,
                quantity: serviceItem.quantity,
                width: serviceItem.width,
                length: serviceItem.length,
                area: serviceItem.area,
                is_rounded: false,
                num_rounded: 4,
                radius: 0,
                service: serviceItem.type,
                side_a: serviceItem.side1,
                side_b: serviceItem.side2,
                is_double: false,
                product_a_id: null,
                product_b_id: null
            };
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
                this.closeModal('serviceModal');
            });
        };
        this.handleServicePriceChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.price = value == '' ? undefined : Number(value);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceWidthChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.width = value == '' ? undefined : Number(value);
            var areaToCalc = Number((newServiceItem.width || 0) * (newServiceItem.side1 || 0)) + Number((newServiceItem.length || 0) * (newServiceItem.side2 || 0));
            newServiceItem.area = Number(areaToCalc / 100) * Number(newServiceItem.quantity || 0);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceLengthChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.length = value == '' ? undefined : Number(value);
            var areaToCalc = Number((newServiceItem.width || 0) * (newServiceItem.side1 || 0)) + Number((newServiceItem.length || 0) * (newServiceItem.side2 || 0));
            newServiceItem.area = Number(areaToCalc / 100) * Number(newServiceItem.quantity || 0);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceAreaChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.area = value == '' ? undefined : Number(value);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceSide1Change = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.side1 = value == '' ? undefined : Number(value);
            var areaToCalc = Number((newServiceItem.width || 0) * (newServiceItem.side1 || 0)) + Number((newServiceItem.length || 0) * (newServiceItem.side2 || 0));
            newServiceItem.area = Number(areaToCalc / 100) * Number(newServiceItem.quantity || 0);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceSide2Change = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.side2 = value == '' ? undefined : Number(value);
            var areaToCalc = Number((newServiceItem.width || 0) * (newServiceItem.side1 || 0)) + Number((newServiceItem.length || 0) * (newServiceItem.side2 || 0));
            newServiceItem.area = Number(areaToCalc / 100) * Number(newServiceItem.quantity || 0);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceQtyChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.quantity = value == '' ? undefined : Number(value);
            var areaToCalc = Number((newServiceItem.width || 0) * (newServiceItem.side1 || 0)) + Number((newServiceItem.length || 0) * (newServiceItem.side2 || 0));
            newServiceItem.area = Number(areaToCalc / 100) * Number(newServiceItem.quantity || 0);
            this.setState({ serviceItem: newServiceItem }, () => {
                this.calculateTotal();
            });
        };
        this.handleServiceTypeChange = (event) => {
            var value = event.target.value;
            var newServiceItem = this.state.serviceItem;
            if (!newServiceItem)
                return;
            newServiceItem.type = value;
            this.setState({ serviceItem: newServiceItem });
        };
        this.state = {
            orderId: '',
            orderNumber: '',
            categories: [],
            products: [],
            cart: [],
            deletedProducts: [],
            customers: [],
            customer: undefined,
            customerName: null,
            customerEmail: null,
            customerMobile: null,
            customerCity: null,
            customerBuilding: null,
            customerStreet: null,
            customerFloor: null,
            customerApartment: null,
            showProducts: false,
            categoryName: null,
            subtotal: 0,
            total: 0,
            tax: 0,
            vatType: this.getAppSettings().vatType,
            deliveryCharge: 0,
            discount: 0,
            searchValue: null,
            remarks: null,
            isFullScreen: isFullScreen(),
            tenderAmount: 0,
            isLoading: false,
            isLoadingCategories: true,
            receiptType: 'glass_receipt',
            doubleVitrageItemA: null,
            doubleVitrageItemB: null,
            doubleVitrageWidth: 1,
            doubleVitrageLength: 1,
            doubleVitrageArea: 0.5,
            doubleVitrageQuantity: 1,
            serviceItem: undefined
        };
    }
    componentDidMount() {
        this.setupForEditing().then(() => {
            this.calculateTotal();
        });
        this.getCategories();
    }
    selectCustomer(customer) {
        this.setState({ customer: customer });
        this.closeModal('customerModal');
    }
    removeCustomer() {
        this.setState({ customer: undefined });
    }
    render() {
        var _b, _j, _k, _q, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex py-3" },
                React.createElement("div", { className: "d-flex align-items-center flex-grow-1" },
                    React.createElement("button", { className: "btn btn-outline-primary me-2", onClick: event => this.goToOrderList() },
                        React.createElement("i", { className: "bi bi-arrow-left fs-5 align-middle" }),
                        " ",
                        t('Back', 'العودة')),
                    React.createElement("button", { className: "btn btn-light me-2 bg-white border d-flex align-items-center justify-content-center", "data-bs-toggle": "modal", "data-bs-target": "#customerModal" },
                        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "hero-icon-sm me-2" },
                            React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" })),
                        t('Customer', 'الزبون'))),
                React.createElement("div", { className: "d-flex" },
                    this.state.receiptType == 'glass_receipt' && (React.createElement("button", { className: "btn btn-light me-2 bg-white border", "data-bs-toggle": "modal", "data-bs-target": "#doubleVitrageModal" }, t('Add Double Vitrage', 'إضافة Double Vitrage'))),
                    React.createElement("select", { name: "receipt-type", id: "receipt-type", className: "form-select form-select-lg me-2", value: this.state.receiptType, onChange: e => this.handleReceiptTypeChange(e) },
                        React.createElement("option", { value: "receipt_default" }, t('Default', 'الافتراضي')),
                        React.createElement("option", { value: "profiles_accessories_receipt" }, t('Aluminum and accessories', 'ألومنيوم و إكسسوار')),
                        React.createElement("option", { value: "glass_receipt" }, t('Glass', 'زجاج'))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white border-bottom-0 p-0" },
                            React.createElement("div", { className: "p-3" },
                                t('Invoice', 'الفاتورة'),
                                " ",
                                React.createElement("span", { className: "fw-bold" }, this.state.orderNumber)),
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 300, className: "p-3 fw-bold" }, t('Item', 'الصنف')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Quantity', 'الكمية')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Total', 'المجموع')))))),
                        React.createElement("div", { className: "card-body p-0 overflow-auto", id: "cartItems" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null, this.state.cart.length > 0 ? (React.createElement(React.Fragment, null, this.state.cart.map((item) => {
                                    var _b;
                                    return (React.createElement("tr", { key: item.cartId },
                                        React.createElement("td", { width: 300 },
                                            React.createElement("div", { className: " d-flex" },
                                                React.createElement("div", { className: "me-2 d-flex align-items-center" },
                                                    React.createElement("img", { src: item.image_url, alt: "img", className: "rounded-2", height: 50 })),
                                                React.createElement("div", null,
                                                    React.createElement("div", { className: "fw-bold" }, item.full_name),
                                                    React.createElement("div", { className: "fw-normal" },
                                                        React.createElement("input", { type: "number", className: "form-control text-center", value: item.price, onFocus: e => e.target.select(), onChange: e => this.updateItemPrice(e, item) })),
                                                    !item.service && (React.createElement("button", { type: "button", className: "btn btn-link btn-sm py-1 px-0 text-decoration-none", "data-bs-toggle": "modal", "data-bs-target": "#serviceModal", onClick: e => this.handleModalServiceBtnClick(item) }, "Add Service"))),
                                                React.createElement("div", { className: "ms-auto d-flex align-items-center" },
                                                    React.createElement("i", { className: "bi bi-x-circle align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeItem(item) })))),
                                        this.state.receiptType == 'glass_receipt' ? (React.createElement(React.Fragment, null, item.service ? (React.createElement(React.Fragment, null,
                                            React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                                React.createElement("div", { className: "fw-bold" },
                                                    item.area,
                                                    " M")),
                                            React.createElement("td", { width: 150, className: "text-center align-middle" }, this.currencyFormatValue((item.area || 0) * (item.price || 0))))) : (React.createElement(React.Fragment, null,
                                            React.createElement("td", { width: 150, className: `p-0 align-middle  cursor-pointer clicable-cell`, "data-bs-toggle": "modal", "data-bs-target": `#m${item.cartId}` },
                                                React.createElement("div", { className: "d-flex justify-content-center" },
                                                    React.createElement("span", null, item.width),
                                                    "x",
                                                    React.createElement("span", null, item.length),
                                                    " =",
                                                    React.createElement("span", { className: "fw-bold" },
                                                        item.area || 0,
                                                        ' ',
                                                        React.createElement("span", { className: "small" },
                                                            ' ',
                                                            this.getAppSettings().areaUnit))),
                                                React.createElement("div", { className: "d-flex justify-content-center" },
                                                    t('Quan.', 'الكمية'),
                                                    ' ',
                                                    React.createElement("span", { className: "fw-bold mx-2" }, item.quantity))),
                                            React.createElement("td", { width: 150, className: "text-center align-middle" }, this.currencyFormatValue((item.area || 0) * (item.price || 0))),
                                            React.createElement("div", { className: "modal zoom-out-entrance", id: `m${item.cartId}`, tabIndex: -1, "aria-labelledby": `m${item.cartId}Label`, "aria-hidden": "true" },
                                                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                                                    React.createElement("div", { className: "modal-content" },
                                                        React.createElement("div", { className: "modal-header" },
                                                            React.createElement("h5", { className: "modal-title", id: `m${item.cartId}Label` }, item.full_name),
                                                            this.modalCloseButton()),
                                                        React.createElement("div", { className: "modal-body" },
                                                            React.createElement("div", { className: "mb-3" },
                                                                React.createElement("label", { className: "form-label fw-bold" },
                                                                    t('Price', 'السعر'),
                                                                    " (",
                                                                    this.getAppSettings().currencySymbol,
                                                                    ")"),
                                                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: item.price, onFocus: e => e.target.select(), onChange: event => this.updateItemPrice(event, item) })),
                                                            React.createElement("div", { className: "mb-3" },
                                                                React.createElement("label", { className: "form-label fw-bold" }, t('Quantity', 'الكمية')),
                                                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) })),
                                                            React.createElement("div", { className: "row mb-3" },
                                                                React.createElement("div", { className: "col-6" },
                                                                    React.createElement("label", { className: "form-label fw-bold" },
                                                                        t('Width', 'العرض'),
                                                                        ' ',
                                                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: item.width, onFocus: e => e.target.select(), onChange: event => this.updateItemWidth(event, item) })),
                                                                React.createElement("div", { className: "col-6" },
                                                                    React.createElement("label", { className: "form-label fw-bold" },
                                                                        t('Length', 'الطول'),
                                                                        ' ',
                                                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: item.length, onFocus: e => e.target.select(), onChange: event => this.updateItemLength(event, item) }))),
                                                            React.createElement("div", { className: "mb-3" },
                                                                React.createElement("label", { className: "form-label fw-bold" },
                                                                    t('Area', 'المساحة'),
                                                                    ' ',
                                                                    React.createElement("span", { className: "small text-muted" }, this.getAppSettings().areaUnit)),
                                                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_b = item.area) !== null && _b !== void 0 ? _b : '', onFocus: e => e.target.select(), onChange: event => this.updateItemArea(event, item) })),
                                                            React.createElement("div", { className: "h5 fw-bold mb-3", dir: "rtl" },
                                                                t('Total Price', 'السعر الاجمالي'),
                                                                ":",
                                                                ' ',
                                                                this.currencyFormatValue((item.area || 0) * (item.price || 0))),
                                                            React.createElement("button", { type: "button", className: "btn btn-link text-decoration-none w-100 border btn-lg", "data-bs-dismiss": "modal" }, t('Done', 'تم')))))))))) : (React.createElement(React.Fragment, null,
                                            React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                                React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) })),
                                            React.createElement("td", { width: 150, className: "text-center align-middle" }, this.currencyFormatValue((item.quantity || 0) * (item.price || 0)))))));
                                }))) : (React.createElement(React.Fragment, null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 3, className: "p-3 text-center align-middle fs-5" }, t('No items added...', 'لا توجد اصناف مضافة ...')))))))),
                        React.createElement("div", { className: " card-footer p-0 bg-white", id: "orderDetails" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200 },
                                            t('Customer', 'الزبون'),
                                            ": ",
                                            this.state.customer ? this.state.customer.name : 'N/A',
                                            this.state.customer && (React.createElement("div", { className: "float-end" },
                                                React.createElement("i", { className: "bi bi-x-circle align-middle text-danger cursor-pointer fs-7 user-select-none", onClick: event => this.removeCustomer() })))),
                                        React.createElement("td", { width: 200, className: "text-end" }, t('Subtotal', 'المجموع')),
                                        React.createElement("td", { width: 200, className: "align-middle text-center" }, this.currencyFormatValue(this.state.subtotal))),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle clicable-cell", "data-bs-toggle": "modal", "data-bs-target": "#deliveryChargeModal" },
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            ":",
                                            ' ',
                                            this.state.deliveryCharge ? this.currencyFormatValue(this.state.deliveryCharge) : 'N/A'),
                                        React.createElement("td", { width: 200, className: "text-end align-middle clicable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, t('Discount', 'الخصم')),
                                        React.createElement("td", { width: 200, className: "text-center text-danger align-middle clicable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, this.currencyFormatValue(this.state.discount || 0))),
                                    React.createElement("tr", { className: " alert-success" },
                                        this.state.vatType == 'add' ? (React.createElement("td", { width: 200, className: "text-start clicable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            t('VAT', 'الضريبة'),
                                            " ",
                                            this.state.tax,
                                            "%: ",
                                            this.currencyFormatValue(this.getTotalTax()))) : (React.createElement("td", { width: 200, className: "text-start clicable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            React.createElement("div", null,
                                                t('TAX.AMOUNT', 'قيمة الضريبة'),
                                                ": ",
                                                this.currencyFormatValue(this.getTaxAmount())),
                                            React.createElement("div", null,
                                                t('VAT', 'الضريبة'),
                                                " ",
                                                this.state.tax,
                                                "%: ",
                                                this.currencyFormatValue(this.getVat())))),
                                        React.createElement("td", { width: 200, className: "fw-bold text-end fs-5 align-middle" }, t('Total', 'الإجمالي')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle fw-bold fs-5" }, this.currencyFormatValue(this.state.total)))))),
                        React.createElement("button", { type: "button", className: "btn btn-info py-4 rounded-0 shadow-sm fs-3 btn-lg w-100", "data-bs-toggle": "modal", "data-bs-target": "#checkoutModal" }, t(' UPDATED CHECKOUT', 'تحديث')))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white" },
                            React.createElement("div", { className: "d-flex px-0", style: { minHeight: 'calc(1.5em + 1rem + 5px)', padding: '0.5rem' } },
                                React.createElement("a", { className: "text-decoration-none cursor-pointer pe-2 fs-5", onClick: event => this.backClick() }, t('CATEGORIES', 'الفئات')),
                                this.state.showProducts && (React.createElement(React.Fragment, null,
                                    React.createElement("i", { className: "bi bi-arrow-right align-middle pe-2 fs-5" }),
                                    React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, this.state.categoryName),
                                    React.createElement("i", { className: "bi bi-arrow-right align-middle pe-2 fs-5" }))))),
                        React.createElement("div", { className: "card-body overflow-auto p-0" },
                            this.state.isLoadingCategories && (React.createElement("div", { className: "py-5" },
                                React.createElement("div", { className: "d-flex justify-content-center m-2" },
                                    React.createElement("div", { className: "spinner-border text-primary", role: "status", style: { width: '4rem', height: '4rem' } },
                                        React.createElement("span", { className: "visually-hidden" }, t('Loading...', 'جاري التحميل...')))),
                                React.createElement("div", { className: "fw-bold h3 text-center" }, t('Loading...', 'جاري التحميل...')))),
                            !this.state.showProducts && (React.createElement(React.Fragment, null, this.state.categories.length > 0 && (React.createElement("div", { className: "row m-0 w-100" }, this.state.categories.map((category) => {
                                return (React.createElement("div", { key: category.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.categoryClick(category) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: category.image_url }),
                                            React.createElement("img", { alt: category.name, src: category.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "product-name", dir: "auto" }, category.name)))));
                            }))))),
                            this.state.showProducts && (React.createElement(React.Fragment, null, this.state.products.length > 0 && (React.createElement("div", { className: "row overflow-auto" }, this.state.products.map((product) => {
                                return (React.createElement("div", { key: product.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.addToCart(product) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: product.image_url }),
                                            React.createElement("img", { alt: product.name, src: product.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "fw-bold", dir: "auto" }, product.full_name),
                                            this.currencyFormatValue(this.specialCustomerPrice(product))))));
                            }))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "serviceModal", tabIndex: -1, "aria-labelledby": "serviceModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header bg-primary text-light" },
                            React.createElement("h5", { className: "modal-title", id: "serviceModalLabel" }, (_b = this.state.serviceItem) === null || _b === void 0 ? void 0 : _b.name),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("div", { className: "mb-3 h3 text-center" }, (_j = this.state.serviceItem) === null || _j === void 0 ? void 0 : _j.type),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("label", { className: "form-label fw-bold" }, t('Price Per Meter', 'سعر المتر')),
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_k = this.state.serviceItem) === null || _k === void 0 ? void 0 : _k.price, onFocus: e => e.target.select(), onChange: event => this.handleServicePriceChange(event) })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("label", { className: "form-label fw-bold" }, t('Quantity', 'الكمية')),
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_q = this.state.serviceItem) === null || _q === void 0 ? void 0 : _q.quantity, onFocus: e => e.target.select(), onChange: event => this.handleServiceQtyChange(event) })),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-6 mb-3" },
                                    React.createElement("label", { className: "form-label fw-bold" },
                                        t('Width', 'العرض'),
                                        " ",
                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_w = this.state.serviceItem) === null || _w === void 0 ? void 0 : _w.width, onFocus: e => e.target.select(), onChange: event => this.handleServiceWidthChange(event) })),
                                React.createElement("div", { className: "col-md-6 mb-3" },
                                    React.createElement("label", { className: "form-label fw-bold" }, t('Sides 1', 'الجوانب')),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_x = this.state.serviceItem) === null || _x === void 0 ? void 0 : _x.side1, onFocus: e => e.target.select(), onChange: event => this.handleServiceSide1Change(event) }))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-6 mb-3" },
                                    React.createElement("label", { className: "form-label fw-bold" },
                                        t('Length', 'الطول'),
                                        " ",
                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_y = this.state.serviceItem) === null || _y === void 0 ? void 0 : _y.length, onFocus: e => e.target.select(), onChange: event => this.handleServiceLengthChange(event) })),
                                React.createElement("div", { className: "col-md-6 mb-3" },
                                    React.createElement("label", { className: "form-label fw-bold" }, t('Sides 2', 'الجوانب')),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_z = this.state.serviceItem) === null || _z === void 0 ? void 0 : _z.side2, onFocus: e => e.target.select(), onChange: event => this.handleServiceSide2Change(event) }))),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("label", { className: "form-label fw-bold" },
                                    t('Total', 'المتر'),
                                    " ",
                                    React.createElement("span", { className: "small text-muted" }, "M")),
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_0 = this.state.serviceItem) === null || _0 === void 0 ? void 0 : _0.area, onFocus: e => e.target.select(), onChange: event => this.handleServiceAreaChange(event) })),
                            React.createElement("div", { className: "h5 fw-bold mb-3", dir: "rtl" },
                                t('Total Price', 'السعر الاجمالي'),
                                ":",
                                ' ',
                                this.currencyFormatValue((((_1 = this.state.serviceItem) === null || _1 === void 0 ? void 0 : _1.area) || 0) * (((_2 = this.state.serviceItem) === null || _2 === void 0 ? void 0 : _2.price) || 0))),
                            React.createElement("div", null,
                                React.createElement("button", { type: "button", className: "btn btn-outline-primary btn-lg w-100", onClick: e => this.handleModalServiceAddBtnClick() }, "Add Service")))))),
            React.createElement("div", { className: "modal", id: "discountModal", tabIndex: -1, "aria-labelledby": "discountModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "discountModalLabel" }, t('Discount', 'الخصم')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.discount || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.discount, onChange: event => this.handleDiscountChange(event) })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "doubleVitrageModal", tabIndex: -1, "aria-labelledby": "doubleVitrageModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "doubleVitrageModalLabel" }, "Double Vitrage"),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("div", { className: "mb-3" },
                                React.createElement(SelectSearch, { search: true, options: this.filterOptions(), value: (_3 = this.state.doubleVitrageItemA) === null || _3 === void 0 ? void 0 : _3.toString(), onChange: value => this.setState({ doubleVitrageItemA: value || null }), placeholder: t('Select Item A', 'اختر الصنف الاول') })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement(SelectSearch, { search: true, onChange: value => this.setState({ doubleVitrageItemB: value || null }), value: (_4 = this.state.doubleVitrageItemB) === null || _4 === void 0 ? void 0 : _4.toString(), options: this.filterOptions(), placeholder: t('Select Item B', 'اختر الصنف الثاني') })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("label", { className: "form-label fw-bold" }, t('Quantity', 'الكمية')),
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.doubleVitrageQuantity, onFocus: e => e.target.select(), onChange: event => this.updateDoubleVitrageItemQuantity(event) })),
                            React.createElement("div", { className: "row mb-3" },
                                React.createElement("div", { className: "col-6" },
                                    React.createElement("label", { className: "form-label fw-bold" },
                                        t('Width', 'العرض'),
                                        " ",
                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.doubleVitrageWidth, onFocus: e => e.target.select(), onChange: event => this.updateDoubleVitrageItemWidth(event) })),
                                React.createElement("div", { className: "col-6" },
                                    React.createElement("label", { className: "form-label fw-bold" },
                                        t('Length', 'الطول'),
                                        " ",
                                        React.createElement("span", { className: "small text-muted" }, this.getAppSettings().measurementUnit)),
                                    React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.doubleVitrageLength, onFocus: e => e.target.select(), onChange: event => this.updateDoubleVitrageItemLength(event) }))),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("label", { className: "form-label fw-bold" },
                                    t('Area', 'المساحة'),
                                    " ",
                                    React.createElement("span", { className: "small text-muted" }, this.getAppSettings().areaUnit)),
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_5 = this.state.doubleVitrageArea) !== null && _5 !== void 0 ? _5 : '', onFocus: e => e.target.select(), onChange: event => this.updateDoubleVitrageItemArea(event) })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("button", { type: "button", className: "btn btn-outline-primary w-100", onClick: e => this.addDoubleVitrageItems(false) }, "Add and Keep edits")),
                            React.createElement("div", null,
                                React.createElement("button", { type: "button", className: "btn btn-outline-dark w-100", onClick: e => this.addDoubleVitrageItems(true) }, "Add and Reset")))))),
            React.createElement("div", { className: "modal", id: "deliveryChargeModal", tabIndex: -1, "aria-labelledby": "deliveryChargeModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "deliveryChargeModalLabel" }, t('Delivery Charge', 'رسوم التوصيل')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.deliveryCharge || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.deliveryCharge, onFocus: e => e.target.select(), onChange: event => this.handleDeliveryChargeChange(event) })))))),
            React.createElement("div", { className: "modal", id: "taxModal", tabIndex: -1, "aria-labelledby": "taxModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "taxModalLabel" }, t('VAT', 'الضريبة')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" },
                                this.state.tax || 0,
                                "%"),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.tax, onChange: event => this.handleTaxChange(event) })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("select", { name: "vatType", id: "vat-type", className: "form-select form-select-lg", onChange: this.handleVatTypeChange, value: this.state.vatType },
                                    React.createElement("option", { value: "exclude" },
                                        " ",
                                        t('Exclude', 'استثناء')),
                                    React.createElement("option", { value: "add" }, t('Add', 'إضافة')))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "customerModal", tabIndex: -1, "aria-labelledby": "customerModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "customerModalLabel" }, t('Customer', 'الزبون')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body p-0" },
                            React.createElement("nav", null,
                                React.createElement("div", { className: "nav nav-tabs nav-justified", id: "nav-tab", role: "tablist" },
                                    React.createElement("button", { className: "nav-link rounded-0 active", id: "nav-search-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-search-customer", type: "button", role: "tab", "aria-controls": "nav-search-customer", "aria-selected": "true" }, t('Search', 'ابحث')),
                                    React.createElement("button", { className: "nav-link rounded-0", id: "nav-create-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-create-customer", type: "button", role: "tab", "aria-controls": "nav-create-customer", "aria-selected": "false" }, t('Create', 'إنشاء')))),
                            React.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                                React.createElement("div", { className: "tab-pane fade show active", id: "nav-search-customer", role: "tabpanel", "aria-labelledby": "nav-search-customer-tab", tabIndex: 0 },
                                    React.createElement("div", { className: "position-relative w-100" },
                                        React.createElement("input", { type: "search", className: "form-control form-control-lg shadow-none", name: "search", id: "search", autoComplete: "off", placeholder: t('Search...', 'بحث...'), onChange: event => this.handleCustomerSearchChange(event) })),
                                    React.createElement("div", { className: "overflow-auto", style: { height: '250px' } }, this.state.customers.length > 0 && (React.createElement(React.Fragment, null, this.state.customers.map((cuts) => {
                                        return (React.createElement("div", { className: "py-2 px-3 clicable-cell border-bottom", onClick: e => this.selectCustomer(cuts), key: cuts.id },
                                            React.createElement("div", { className: "fw-bold" }, cuts.name),
                                            React.createElement("div", { className: "small text-muted" }, cuts.contact),
                                            React.createElement("div", { className: "small text-muted" }, cuts.full_address)));
                                    }))))),
                                React.createElement("div", { className: "tab-pane fade p-3", id: "nav-create-customer", role: "tabpanel", "aria-labelledby": "nav-create-customer-tab", tabIndex: 0 },
                                    React.createElement("form", { method: "POST", onSubmit: this.createCustomer, role: "form", id: "create-customer-form" },
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" },
                                                t('Customer Name', 'اسم الزبون'),
                                                "*"),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerNameChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Email', 'البريد الإلكتروني')),
                                            React.createElement("input", { type: "email", className: "form-control form-control-lg", onChange: event => this.handleCustomerEmailChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Mobile Number', 'رقم الجوال')),
                                            React.createElement("input", { type: "tel", className: "form-control form-control-lg", onChange: event => this.handleCustomerMobileChange(event) })),
                                        React.createElement("div", { className: "text-muted" }, t('Address', 'العنوان')),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('City', 'المدينة')),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCityChange(event) })),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Street', 'الشارع')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerStreetChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Building', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerBuildingChange(event) }))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Floor', 'الطابق')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerFloorChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Apartment', 'الشقة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerApartmentChange(event) }))),
                                        React.createElement("button", { className: "btn btn-primary btn-lg w-100", type: "submit", disabled: this.state.isLoading }, t('Create Customer', 'إنشاء زبون جديد'))))))))),
            React.createElement("div", { className: "modal fade", id: "checkoutModal", tabIndex: -1, "aria-labelledby": "checkoutModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered modal-lg" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "checkoutModalLabel" }),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body py-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-6 py-3 bg-primary-sec" },
                                    React.createElement("table", { className: "table table-borderless" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Subtotal', 'المجموع')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.subtotal))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Quantity', 'الكمية')),
                                                React.createElement("td", { className: "text-white" }, this.state.cart.reduce(function (prev, current) {
                                                    return prev + +(current.quantity || 0);
                                                }, 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Discount', 'الخصم')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.discount || 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" }, t('Delivery Charge', 'رسوم التوصيل')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.deliveryCharge || 0))),
                                            this.state.vatType == 'add' ? (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    t('VAT', 'الضريبة'),
                                                    " ",
                                                    this.state.tax || 0,
                                                    "%"),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTotalTax())))) : (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        " ",
                                                        t('Tax Amount', 'القيمة الضريبية')),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getTaxAmount()))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        t('VAT', 'الضريبة'),
                                                        " ",
                                                        this.state.tax || 0,
                                                        "%"),
                                                    React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.getVat()))))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, t('Total', 'المجموع الإجمالي')),
                                                React.createElement("td", { className: "text-white" }, this.currencyFormatValue(this.state.total))),
                                            this.state.customer && (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Customer', 'الزبون')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.name)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Contact', 'الاتصال')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.contact)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Address', 'العنوان')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.full_address)))))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "remarks", className: "form-label text-danger-sec" }, t('Notes', 'الملاحظات')),
                                        React.createElement("textarea", { className: "form-control", id: "remarks", rows: 3, onChange: event => this.handleRemarksChange(event), value: this.state.remarks || '' }))),
                                React.createElement("div", { className: "col-6 py-3 bg-light d-flex flex-column" },
                                    React.createElement("div", { className: "text-center text-danger" }, t('CHECKOUT', 'الدفع')),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" }, t('Tender Amount', 'المبلغ المدفوع')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", id: "tender-amount", value: this.state.tenderAmount, onFocus: e => e.target.select(), onChange: event => this.handleTenderAmountChange(event) })),
                                    React.createElement("hr", null),
                                    React.createElement("table", { className: "table table-borderless d-none" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, this.getChangeAmount() < 0 ? t('Owe', 'مدين') : t('Change', 'الباقي')),
                                                React.createElement("td", { className: "text-end" }, this.currencyFormatValue(this.getChangeAmount()))))),
                                    React.createElement("div", { className: "mt-auto" },
                                        React.createElement("button", { className: "btn btn-info border btn-lg w-100", disabled: this.state.isLoading, onClick: e => this.updateOrder() }, t('UPDATE', 'تحديث'))))))))),
            React.createElement(ToastContainer, { position: "bottom-left", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default PointOfSaleEdit;
const element = document.getElementById('pos-edit');
if (element) {
    const props = Object.assign({}, element.dataset);
    const root = ReactDOM.createRoot(element);
    root.render(React.createElement(PointOfSaleEdit, Object.assign({ order: '', settings: '' }, props)));
}
